(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').trim().toUpperCase().replace(/\s+/g, '').replace(/[‐‑–—−]/g, '-');
  }

  // walk62: part numbers typed without dashes/spaces/slashes (CX441, 221412) match the
  // catalog SKU (CX-441, 221-412) through a compact key built from the exact-SKU index.
  function compact(value) {
    return normalize(value).replace(/[^A-Z0-9]/g, '');
  }

  var exactIndexPromise;
  function loadExactIndex() {
    if (!exactIndexPromise) {
      exactIndexPromise = fetch(assetUrl('exact'), { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('index unavailable');
        return response.json();
      }).catch(function (error) { exactIndexPromise = undefined; throw error; });
    }
    return exactIndexPromise;
  }

  function lookupHandles(index, raw) {
    var map = index.exactSkuToHandles || {};
    var query = normalize(raw);
    if (map[query] && map[query].length) return { handles: map[query], sku: query };
    var key = compact(raw);
    if (!key) return { handles: [], sku: '' };
    if (!index._usacCompact) {
      var c = {};
      Object.keys(map).forEach(function (sku) {
        var k = compact(sku);
        if (!c[k]) c[k] = { handles: [], sku: sku };
        map[sku].forEach(function (h) { if (c[k].handles.indexOf(h) < 0) c[k].handles.push(h); });
      });
      index._usacCompact = c;
    }
    return index._usacCompact[key] || { handles: [], sku: '' };
  }
  window.USAC_LOOKUP_PART = function (raw) {
    return loadExactIndex().then(function (index) { return lookupHandles(index, raw); });
  };

  function showMessage(form, text) {
    var node = form.querySelector('.exact-part-message');
    if (node) node.textContent = text;
  }

  function assetUrl(name) {
    var urls = window.USAC_ASSET_URLS || {};
    if (name === 'exact') return urls.exactSku || '';
    if (name === 'relationships') return urls.productRelationships || '';
    if (name === 'hierarchies') return urls.productHierarchies || '';
    return urls.sourceManifests && urls.sourceManifests[name] || '';
  }

  document.querySelectorAll('[data-exact-part-form]').forEach(function (lookup) {
    lookup.addEventListener('submit', function (event) {
      var input = lookup.querySelector('input[name="q"]');
      var query = normalize(input && input.value);
      if (!query) return;
      event.preventDefault();
      var button = lookup.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      loadExactIndex().then(function (index) {
        var match = lookupHandles(index, query);
        var handles = match.handles;
        if (handles.length === 1) {
          window.location.href = '/products/' + handles[0];
          return;
        }
        if (handles.length > 1) showMessage(lookup, 'This part number matches more than one product. Showing search results.');
        window.location.href = '/search?q=' + encodeURIComponent(match.sku || query) + '&type=product&options%5Bprefix%5D=none';
      }).catch(function () {
        HTMLFormElement.prototype.submit.call(lookup);
      }).finally(function () {
        if (button) button.disabled = false;
      });
    });
  });

  // walk62: on /search, an exact single part-number match (with or without dashes) opens the
  // product directly, as the page copy promises. Add &exact=0 to the URL to stay on the results.
  var searchRoot = document.querySelector('[data-usac-search]');
  if (searchRoot && searchRoot.getAttribute('data-terms')) {
    var terms = searchRoot.getAttribute('data-terms');
    var params = new URLSearchParams(window.location.search);
    var note = searchRoot.querySelector('[data-usac-search-exact]');
    if (params.get('exact') !== '0' && compact(terms) && compact(terms).length >= 3) {
      loadExactIndex().then(function (index) {
        var match = lookupHandles(index, terms);
        if (match.handles.length === 1) {
          if (note) { note.textContent = 'Opening part ' + match.sku + '…'; note.hidden = false; }
          window.location.replace('/products/' + match.handles[0]);
        } else if (match.handles.length > 1 && note) {
          note.textContent = 'Part ' + match.sku + ' is sold in more than one listing: ';
          match.handles.slice(0, 8).forEach(function (h, i) {
            if (i) note.appendChild(document.createTextNode(' · '));
            var a = document.createElement('a'); a.href = '/products/' + h; a.textContent = h; note.appendChild(a);
          });
          note.hidden = false;
        }
      }).catch(function () {});
    }
  }

  var route = document.querySelector('[data-discovery-route]');
  if (route) {
    var vendor = route.getAttribute('data-vendor') || route.getAttribute('data-discovery-route').split('-')[0];
    var status = document.querySelector('[data-source-status]');
    if (status) fetch(assetUrl(vendor)).then(function (response) {
      if (!response.ok) throw new Error('catalog unavailable');
      return response.json();
    }).then(function (manifest) {
      var key = route.getAttribute('data-discovery-route');
      var routeData = manifest.routes && manifest.routes[key];
      status.textContent = routeData
        ? (routeData.candidateCount || 0) + ' parts in this family. Exact part-number lookup is available above.'
        : 'Use the exact part-number search above.';
    }).catch(function () {
      status.textContent = 'Exact-part lookup is available for this collection.';
    });
  }

  /* filters128 (2026-10-29): results update on each tick; ticked values stay visible; remove chips; remove-last / clear-all. */
  (function () {
    var forms = document.querySelectorAll('[data-compact-filters]');
    if (!forms.length) return;
    var KEY = 'usacFilterState', ORDER = 'usacFilterOrder';
    function getOrder() { try { var o = JSON.parse(sessionStorage.getItem(ORDER) || 'null'); return o && o.path === window.location.pathname ? o.list : []; } catch (e) { return []; } }
    function noteAdded(cb) {
      if (!cb || !cb.checked) return;
      try { var list = getOrder().filter(function (x) { return !(x[0] === cb.name && x[1] === cb.value); }); list.push([cb.name, cb.value]); sessionStorage.setItem(ORDER, JSON.stringify({ path: window.location.pathname, list: list.slice(-30) })); } catch (e) {}
    }

    function isFilterKey(k) { return k.indexOf('filter.') === 0; }
    function prettyKey(k) {
      var last = k.split('.').pop().replace(/^filter_/, '').replace(/_/g, ' ');
      if (k === 'filter.v.availability') last = 'availability';
      if (k.indexOf('filter.v.price') === 0) last = k.slice(-3) === 'gte' ? 'price from' : 'price to';
      return last.charAt(0).toUpperCase() + last.slice(1);
    }
    function urlWithout(test) {
      var p = new URLSearchParams(window.location.search), out = new URLSearchParams();
      var entries = [];
      p.forEach(function (v, k) { entries.push([k, v]); });
      entries.forEach(function (e, i) { if (!test(e[0], e[1], i, entries) && e[0] !== 'page') out.append(e[0], e[1]); });
      var qs = out.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }
    function urlFilters() {
      var list = [];
      new URLSearchParams(window.location.search).forEach(function (v, k) { if (isFilterKey(k) && v !== '') list.push([k, v]); });
      return list;
    }

    function restore(form) {
      try {
        var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        sessionStorage.removeItem(KEY);
        if (!s || s.path !== window.location.pathname) return;
        if (s.group) {
          var g = form.querySelector('[data-filter-param="' + s.group.replace(/"/g, '') + '"]');
          if (g) { g.open = true; g.setAttribute('open', ''); }
        }
        window.scrollTo(0, s.y || 0);
      } catch (e) {}
    }

    function go(form, group) {
      try { sessionStorage.setItem(KEY, JSON.stringify({ path: window.location.pathname, y: window.scrollY, group: group ? group.getAttribute('data-filter-param') : '' })); } catch (e) {}
      form.querySelectorAll('input[type="number"], input[type="hidden"][name="sort_by"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
      form.classList.add('is-loading');
      var list = document.getElementById('usac-products') || document.querySelector('.product-list');
      if (list) list.setAttribute('aria-busy', 'true');
      form.submit();
    }

    forms.forEach(function (form) {
      var instant = form.hasAttribute('data-usac-instant-filters');

      function updateSelection(group) {
        var selected = group.querySelectorAll('[data-filter-checkbox]:checked').length;
        var summary = group.querySelector('[data-filter-selection]');
        if (summary && group.querySelector('[data-filter-checkbox]')) summary.textContent = selected ? selected + ' selected' : 'Any';
      }

      // Ticked values Shopify did not echo back (0 matches) still get a checked box so they can be unticked.
      var have = {};
      form.querySelectorAll('[data-filter-checkbox]:checked').forEach(function (c) { have[c.name + '\u0000' + c.value] = true; });
      var missing = urlFilters().filter(function (e) { return e[0].indexOf('filter.v.price') !== 0 && !have[e[0] + '\u0000' + e[1]]; });
      if (missing.length) {
        var acc = form.querySelector('.filter-accordion');
        if (acc) {
          var extra = document.createElement('details');
          extra.className = 'filter-group'; extra.open = true; extra.setAttribute('open', '');
          extra.setAttribute('data-filter-group', ''); extra.setAttribute('data-filter-param', 'usac-other');
          extra.innerHTML = '<summary><span>Your other choices</span><span class="filter-group__selection" data-filter-selection></span></summary><div class="filter-group__options"></div>';
          var box = extra.querySelector('.filter-group__options');
          missing.forEach(function (e) {
            var label = document.createElement('label'); label.className = 'filter-value is-orphan';
            var input = document.createElement('input'); input.type = 'checkbox'; input.checked = true; input.name = e[0]; input.value = e[1]; input.setAttribute('data-filter-checkbox', '');
            var span = document.createElement('span'); span.textContent = prettyKey(e[0]) + ': ' + e[1];
            var small = document.createElement('small'); small.textContent = '(0)';
            label.appendChild(input); label.appendChild(document.createTextNode(' ')); label.appendChild(span); label.appendChild(document.createTextNode(' ')); label.appendChild(small);
            box.appendChild(label);
          });
          acc.insertBefore(extra, acc.firstChild);
        }
      }

      form.querySelectorAll('[data-filter-group]').forEach(function (group) {
        updateSelection(group);
        group.querySelectorAll('[data-filter-checkbox]').forEach(function (checkbox) {
          checkbox.addEventListener('change', function () {
            updateSelection(group);
            if (instant) { noteAdded(checkbox); go(form, group); }
          });
        });
        group.querySelectorAll('input[type="number"]').forEach(function (input) {
          input.addEventListener('change', function () { if (instant) go(form, group); });
        });
      });

      if (instant) {
        var btn = form.querySelector('[data-filter-submit]');
        if (btn) btn.hidden = true;
        var help = form.querySelector('[data-filter-help]');
        if (help) help.textContent = 'Tick the requirements that apply. Results update with each choice, and the number beside each option shows how many parts match.';
        form.addEventListener('submit', function (ev) { ev.preventDefault(); go(form, null); });
        restore(form);
      }
    });

    // Chips for URL filters Shopify did not echo back.
    var all = urlFilters();
    var chips = document.querySelector('[data-filter-chips]');
    if (chips && all.length) {
      var known = {};
      chips.querySelectorAll('[data-filter-chip][data-param]').forEach(function (a) { known[a.getAttribute('data-param') + '\u0000' + a.getAttribute('data-value')] = true; });
      var hasPriceChip = !!chips.querySelector('[data-filter-chip="price"]');
      var clear = chips.querySelector('.usac-filter-chips__clear');
      all.forEach(function (e) {
        if (known[e[0] + '\u0000' + e[1]]) return;
        if (e[0].indexOf('filter.v.price') === 0 && hasPriceChip) return;
        var a = document.createElement('a'); a.className = 'usac-filter-chip';
        a.href = urlWithout(function (k, v) { return k === e[0] && v === e[1]; });
        a.textContent = prettyKey(e[0]) + ': ' + e[1] + ' ';
        var x = document.createElement('span'); x.setAttribute('aria-hidden', 'true'); x.textContent = '×'; a.appendChild(x);
        a.setAttribute('aria-label', 'Remove filter ' + prettyKey(e[0]) + ': ' + e[1]);
        chips.insertBefore(a, clear);
      });
      chips.hidden = false;
    }

    // Empty state: "Remove last filter" removes the most recently added filter (last in the URL).
    var empty = document.querySelector('[data-filter-empty]');
    if (empty && all.length) {
      var last = -1, idx = 0, entries = [];
      new URLSearchParams(window.location.search).forEach(function (v, k) { entries.push([k, v]); if (isFilterKey(k) && v !== '') last = idx; idx++; });
      // Prefer the box ticked most recently (form submits list boxes in panel order, not click order).
      var ord = getOrder();
      for (var oi = ord.length - 1; oi >= 0; oi--) {
        var hit = -1;
        entries.forEach(function (e, i) { if (e[0] === ord[oi][0] && e[1] === ord[oi][1]) hit = i; });
        if (hit > -1) { last = hit; break; }
      }
      var rl = empty.querySelector('[data-filter-remove-last]');
      if (rl && last > -1) {
        rl.href = urlWithout(function (k, v, i) { return i === last; }); rl.hidden = false;
        rl.textContent = 'Remove last filter (' + prettyKey(entries[last][0]) + ': ' + entries[last][1] + ')';
      }
      empty.querySelectorAll('[data-filter-clear]').forEach(function (a) { a.hidden = false; });
      var t = empty.querySelector('[data-filter-empty-text]');
      if (t) t.textContent = 'None of the parts in this list match every filter you chose. Remove the last filter you added, start over, or ask our team, who can often suggest an equivalent part.';
    }

    window.addEventListener('pageshow', function () {
      forms.forEach(function (form) {
        form.classList.remove('is-loading');
        form.querySelectorAll('input[type="number"], input[type="hidden"][name="sort_by"]').forEach(function (i) { i.disabled = false; });
      });
    });
  })();

  document.querySelectorAll('.product-form select').forEach(function (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var price = document.querySelector('.price');
      if (price && option) {
        var form = select.closest('form');
        if (form) form.dataset.selectedVariant = option.value;
      }
      select.dispatchEvent(new CustomEvent('usac:product-configuration-changed', {
        bubbles: true,
        detail: { sku: option && option.dataset.sku || '' },
      }));
    });
  });

  function relatedProductCard(reference) {
    var card = document.createElement('a');
    card.className = 'product-relationship-card';
    card.href = '/products/' + reference.handle;
    var sku = document.createElement('span');
    sku.className = 'product-relationship-card__sku';
    sku.textContent = 'Part # ' + reference.sku;
    var title = document.createElement('strong');
    title.textContent = reference.title || reference.sku;
    var action = document.createElement('span');
    action.className = 'product-relationship-card__action';
    action.textContent = 'View product →';
    card.append(sku, title, action);
    return card;
  }

  function startProductRelationships(root) {
    var relationshipAsset = assetUrl('relationships');
    if (!relationshipAsset) return;
    var selectedSku = root.dataset.productSku || '';
    var groups = root.querySelector('.product-relationships__groups');
    var relationshipData;

    function render(sku) {
      if (!relationshipData || !groups) return;
      selectedSku = sku || selectedSku;
      var relationships = relationshipData.products && relationshipData.products[normalize(selectedSku)];
      groups.replaceChildren();
      root.hidden = true;
      if (!relationships) return;
      [
        ['accessories', 'Accessories & tools'],
        ['related', 'Related products'],
        ['alternatives', 'Related alternatives'],
      ].forEach(function (definition) {
        var records = relationships[definition[0]] || [];
        if (!records.length) return;
        var group = document.createElement('section');
        group.className = 'product-relationship-group';
        var heading = document.createElement('h3');
        heading.textContent = definition[1];
        var list = document.createElement('div');
        list.className = 'product-relationship-grid';
        records.forEach(function (reference) { list.appendChild(relatedProductCard(reference)); });
        group.append(heading, list);
        groups.appendChild(group);
      });
      root.hidden = !groups.childElementCount;
    }

    fetch(relationshipAsset, { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('relationship asset unavailable');
      return response.json();
    }).then(function (data) {
      relationshipData = data;
      render(selectedSku);
      document.querySelectorAll('[data-product-relationship-select]').forEach(function (select) {
        select.addEventListener('usac:product-configuration-changed', function (event) {
          render(event.detail && event.detail.sku);
        });
      });
    }).catch(function () {
      root.hidden = true;
    });
  }

  document.querySelectorAll('[data-related-products]').forEach(startProductRelationships);

  function startProductHierarchy(root) {
    var hierarchyAsset = assetUrl('hierarchies');
    var links = root.querySelector('[data-product-hierarchy-links]');
    var select = document.querySelector('[data-product-relationship-select]');
    var hierarchyData;
    var structuredDataScript = document.querySelector('script[type="application/ld+json"]');
    var fallbackStructuredData = structuredDataScript && structuredDataScript.textContent;
    if (!hierarchyAsset || !links) return;

    function updateStructuredData(path) {
      var script = structuredDataScript;
      if (!script) return;
      try {
        var data = JSON.parse(script.textContent);
        var breadcrumb = data['@graph'] && data['@graph'].find(function (item) {
          return item['@type'] === 'BreadcrumbList';
        });
        if (!breadcrumb) return;
        var items = [{ '@type': 'ListItem', position: 1, name: 'Home', item: window.location.origin }];
        path.forEach(function (item, index) {
          items.push({ '@type': 'ListItem', position: index + 2, name: item.title, item: window.location.origin + item.url });
        });
        items.push({
          '@type': 'ListItem',
          position: items.length + 1,
          name: document.title.replace(/\s+—\s+US Automation Controls$/, ''),
          item: window.location.href,
        });
        breadcrumb.itemListElement = items;
        script.textContent = JSON.stringify(data);
      } catch (_) {
        // Preserve the honest server-rendered fallback if structured data cannot be updated.
      }
    }

    var parentLink = root.querySelector('[data-breadcrumb-parent]');

    function showFallback() {
      links.replaceChildren();
      links.hidden = true;
      if (parentLink) parentLink.hidden = false;
    }

    function render(sku) {
      if (!hierarchyData) return;
      var path = hierarchyData.products && hierarchyData.products[normalize(sku)];
      if (!path || !path.length) {
        showFallback();
        if (structuredDataScript && fallbackStructuredData) structuredDataScript.textContent = fallbackStructuredData;
        return;
      }
      // The catalog path (manufacturer > category > series) replaces the single collection
      // parent so no segment is repeated; separators come from CSS.
      links.replaceChildren();
      path.forEach(function (item) {
        var link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        links.append(link);
      });
      links.hidden = false;
      if (parentLink) parentLink.hidden = true;
      updateStructuredData(path);
    }

    fetch(hierarchyAsset, { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('product hierarchy asset unavailable');
      return response.json();
    }).then(function (data) {
      hierarchyData = data;
      var option = select && select.options[select.selectedIndex];
      render(option && option.dataset.sku || '');
      if (select) select.addEventListener('usac:product-configuration-changed', function (event) {
        render(event.detail && event.detail.sku);
      });
    }).catch(function () {
      showFallback();
    });
  }

  document.querySelectorAll('[data-product-breadcrumb]').forEach(startProductHierarchy);
})();